import { useThree } from "@react-three/fiber"
import Music from "./Music"
import Sfx from "./Sfx"
import { useLayoutEffect } from "react"
import * as THREE from 'three'
import ActiveAudio from "./ActiveAudio"


export default function AudioComponent() {
    const { camera } = useThree()

    useLayoutEffect(() => {
        const listener = new THREE.AudioListener()
        listener.name = "AudioListener"

        camera.add(listener)

        return () => {
            if (listener && listener.parent === camera) {
                camera.remove(listener)
            }
        }
    }, [camera])
    
    return (
        <>
            <ActiveAudio/>
            <Music />
            <Sfx />
        </>
    )
}